import React from 'react';
import { useIntl } from 'react-intl';
import config from '../../config';
import { FormattedMessage } from '../../util/reactIntl';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import css from './SafetyCenterPage.module.css';
import safety1 from './safety1.jpg';
import safety2 from './safety2.jpeg';



const SafetyCenterPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const intl = useIntl();

  // SEO Keywords
  const primaryKeywords = [
    "Host4Euro safety information",
    "Safety tips Host4Euro",
    "Host4Euro user safety",
    "Reporting issues Host4Euro",
    "Host4Euro security guidelines"
  ];
  const secondaryKeywords = [
    "Safe communication on Host4Euro",
    "Contact points Host4Euro",
    "Personal information safety Host4Euro",
    "Safety recommendations Host4Euro",
    "Telephone helplines Germany"
  ];

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'SafetyCenter.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'SafetyCenter.schemaDescription' }, { siteTitle });

  // prettier-ignore
  return (
    <StaticPage
      title={schemaTitle}
      description={schemaDescription}
      primaryKeywords={primaryKeywords}
      secondaryKeywords={secondaryKeywords}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'SafetyCenterPage',
        name: schemaTitle,
        description: schemaDescription,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <center>
            <h1>
              <FormattedMessage id="SafetyCenter.title1" />
            </h1>
          </center>
          <p>
            <FormattedMessage id="SafetyCenter.text1part1" />
          </p>
          <p>
            <FormattedMessage id="SafetyCenter.text1part2" />
            <a href="mailto:contact@host4euro.com">
              <FormattedMessage id="SafetyCenter.link1" />
            </a>
          </p>

          <center>
            <h1>
              <FormattedMessage id="SafetyCenter.title2" />
            </h1>
          </center>
          <p>
            <FormattedMessage id="SafetyCenter.text2" />
          </p>

          <center>
            <h1>
              <FormattedMessage id="SafetyCenter.title3" />
            </h1>
          </center>
          <div className={css.imagesWrapper}>
            <img src={safety1} className={css.coverImage} />
            <img src={safety2} className={css.coverImage} />
          </div>
          <p>
            <FormattedMessage id="SafetyCenter.text3" />
          </p>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default SafetyCenterPage;
